import { render } from "./MyApp.vue?vue&type=template&id=41637097"
import script from "./MyApp.vue?vue&type=script&lang=js"
export * from "./MyApp.vue?vue&type=script&lang=js"

import "./MyApp.vue?vue&type=style&index=0&id=41637097&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__